import React, { useState } from "react";
import { CreditCard, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { paymentsAPI } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

// Pay €0.50 (SM) or €1 (IT) to publish a business listing
export default function PayListingButton({ listingId }) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const isIT = user?.country === "IT";
  const amount = isIT ? "1,00" : "0,50";
  const pkgId = isIT ? "business_listing_fee_it" : "business_listing_fee";

  const pay = async () => {
    setLoading(true);
    try {
      const { url } = await paymentsAPI.createBusinessListingFee(listingId, window.location.origin, pkgId);
      if (url) {
        window.location.href = url;
        return;
      }
      toast.error("Errore creazione sessione di pagamento");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore pagamento");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      onClick={pay}
      disabled={loading}
      size="sm"
      className="bg-amber-500 hover:bg-amber-600 text-white rounded-full h-8 px-3 text-xs font-bold"
      data-testid={`pay-listing-${listingId}`}
    >
      {loading ? <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" /> : <CreditCard className="w-3.5 h-3.5 mr-1" />}
      Paga €{amount} e pubblica
    </Button>
  );
}
